import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AdminStats = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get('https://.../admin/stats')
      .then(res => setStats(res.data))
      .catch(err => console.error('Erreur stats :', err));
  }, []);

  return (
    <div>
      <h2>📊 Statistiques générales</h2>
      {stats ? (
        <ul>
          <li>Nombre de patients : {stats.total_patients}</li>
          <li>Nombre de professionnels : {stats.total_professionals}</li>
          <li>Rendez-vous pris : {stats.total_appointments}</li>
          <li>Rendez-vous annulés : {stats.cancelled_appointments}</li>
        </ul>
      ) : (
        <p>Chargement...</p>
      )}
    </div>
  );
};

export default AdminStats;